export enum PlanningType {
    Pickup = 0,
    Delivery = 1,
    Schedule = 999
}
